import axios from "axios";

import config from "./config";

export default class BoletoService {
  static async getBoleto(cpf) {
    const bodyFormData = new FormData();
    bodyFormData.append("servico", "getBoletos");
    bodyFormData.append("cpf",cpf);
    let response = "";
    try {
      response = await axios.post(config.API_URL_BASE, bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    } catch (err) {
        return {status: false, error:err};
    }
    return response.data
  }
}
